import React from 'react';
export function EmailOpenIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.757 2.535a3 3 0 00-3.514 0l-7 5.056A3 3 0 002 10.023V19a3 3 0 003 3h14a3 3 0 003-3v-8.977a3 3 0 00-1.244-2.432l-7-5.056zm-2.342 1.621a1 1 0 011.17 0l7 5.056a1 1 0 01.415.81v.257l-7.684 2.562a1 1 0 01-.632 0L4 10.279v-.256a1 1 0 01.415-.811l7-5.056zM4 12.387l7.051 2.35a3 3 0 001.897 0L20 12.388V19a1 1 0 01-1 1H5a1 1 0 01-1-1v-6.613z"
  }));
}